/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentGuardianSetIndex",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "getGuardianSet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGuardianSetExpiry",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "emitter",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "targetChainId",
                type: "uint16",
            },
        ],
        name: "nextSequence",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseAndVerifyVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "guardianIndex",
                        type: "uint8",
                    },
                ],
                internalType: "struct Structs.Signature[]",
                name: "signatures",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "guardianSet",
                type: "tuple",
            },
        ],
        name: "verifySignatures",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "targetChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "numGuardians",
                type: "uint256",
            },
        ],
        name: "quorum",
        outputs: [
            {
                internalType: "uint256",
                name: "numSignaturesRequiredForQuorum",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
export class Messages__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Messages__factory.bytecode = _bytecode;
Messages__factory.abi = _abi;
